<div class="header">
    <div class="header-main wrapper">
        <div class="header_top-links">
            <app-profile-menu-container></app-profile-menu-container>
        </div>
    </div>
</div>